import type { AnalyticsRange } from "@lafayette/schemas";

import { Button } from "../../ui/button";
import { cn } from "../../ui/cn";
import { RANGE_OPTIONS } from "../overview-model";

// The time range of the cockpit: 24 h, 7 d, 30 d, 90 d, 12 m, All. A group of buttons, one of them pressed (the Paper control: a muted track with
// the chosen range raised on a white pill). The range is in the address, so a reload and a link keep it. A change of range is NOT an opening.

export function RangeControl({
  value,
  onChange,
}: Readonly<{ value: AnalyticsRange; onChange: (range: AnalyticsRange) => void }>) {
  return (
    // biome-ignore lint/a11y/useSemanticElements: a group of toggle buttons; a fieldset would add a border and a legend that this control does not want
    <div
      role="group"
      aria-label="Time range"
      className="inline-flex gap-0.5 compact:gap-2 rounded-xl border border-hairline bg-muted p-[3px]"
    >
      {RANGE_OPTIONS.map((option) => {
        const pressed = option.value === value;
        return (
          <Button
            key={option.value}
            type="button"
            variant="ghost"
            aria-pressed={pressed}
            onClick={() => onChange(option.value)}
            className={cn(
              "rounded-[9px] px-2.5 text-[13px] leading-[18px] font-medium compact:h-8",
              pressed
                ? "bg-card font-semibold text-foreground hover:bg-card"
                : "text-muted-foreground hover:bg-transparent hover:text-foreground",
            )}
          >
            <span aria-hidden="true">{option.label}</span>
            <span className="sr-only">{option.spoken}</span>
          </Button>
        );
      })}
    </div>
  );
}
